import { BaseController } from "@app/views/base.view";
import { Utils } from "@tools";
import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { DrawerService } from "@app/services/drawer.service";

export interface IDrawerScope extends ng.IScope {
    drawerService: DrawerService;
}

@NgView({
    token: Token.DrawerView,
    dependencies: [
        Token.$Scope,
        Token.DrawerService,
        Token.$Timeout,
    ]
})
export class DrawerController extends BaseController {

    constructor(
        public $scope: IDrawerScope,
        public drawerService: DrawerService,
        $timeout: ng.ITimeoutService
    ) {

        super();

        $scope.drawerService = drawerService;

        // routine for resizing drawer buttons if there are too many
        let resizeDrawer = Utils.throttle(() => {
            let $drawerButtons = jQuery(".kb-drawer__buttons");
            let totalWidth: number;
            $drawerButtons.find(".kb-drawer__button").each((i, e) => {
                totalWidth += jQuery(e).outerWidth();
            });

            $drawerButtons.toggleClass("is-icons-only", totalWidth > $drawerButtons.innerWidth());
        }, 100);

        $scope.$watchCollection("drawerService.drawers", () => {
            resizeDrawer();
        });

        // track the window size
        jQuery(window).resize(() => {
            resizeDrawer();
        });
    }
}
